import { useState } from "react";
import { Button } from "react-bootstrap";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await fetch("https://api-ft5g.onrender.com/forgot-password", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
        });

        const data = await response.text();
        setMessage(data);
    };

    return (
        <div>
            <h2 className="text-center">Forgot Password</h2>
            <form onSubmit={handleSubmit} className="text-center">
                <input className="me-3 mt-2" type="email" placeholder="Enter Email" value={email} onChange={e => setEmail(e.target.value)} required />
                <Button type="submit">Send Reset Link</Button>
            </form>
            <p className="text-center">{message}</p>
        </div>
    );
};

export default ForgotPassword;